<template lang="pug">
div
  header
    h1 Edit API Key
  Form
</template>

<script>
  import { mapStores } from 'pinia'
  import { useApiClientStore } from '@/stores/api_client'

  import Form from '../shared/form.vue'

  export default {
    components: {
      Form
    },

    props: {
      apiClientId: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        loading: true
      }
    },

    computed: {
      ...mapStores(useApiClientStore)
    },

    mounted() {
      this.apiClientStore.$reset()
      this.apiClientStore.fetch(this.apiClientId)

      this.loading = false
    }
  }
</script>
